import {
  head,
  orderBy,
  isEmpty,
  filter,
  clone,
  cloneDeep,
  map,
  concat,
  findLast,
  reverse,
  find,
  findIndex,
  isObject,
  forEach,
  remove,
  unset,
  has,
  omit,
  chunk,
  union,
  merge,
  pick,
  pickBy,
  capitalize,
  camelCase,
  uniqBy,
  isEqual,
  get,
} from 'lodash';

export default {
  head,
  orderBy,
  isEmpty,
  filter,
  clone,
  cloneDeep,
  map,
  concat,
  findLast,
  reverse,
  find,
  findIndex,
  isObject,
  forEach,
  remove,
  unset,
  has,
  omit,
  chunk,
  union,
  merge,
  pick,
  pickBy,
  capitalize,
  camelCase,
  uniqBy,
  isEqual,
  get,
};
